export const GET_ALL_WORKSPACES_REQUEST = 'GET_ALL_WORKSPACES_REQUEST'
export const GET_ALL_WORKSPACES_SUCCESS = 'GET_ALL_WORKSPACES_SUCCESS'
export const GET_ALL_WORKSPACES_FAIL = 'GET_ALL_WORKSPACES_FAIL'
export const GET_ALL_WORKSPACES_RESET = 'GET_ALL_WORKSPACES_RESET'

export const GET_CURRENT_WORKSPACE_REQUEST = 'GET_CURRENT_WORKSPACE_REQUEST'
export const GET_CURRENT_WORKSPACE_SUCCESS = 'GET_CURRENT_WORKSPACE_SUCCESS'
export const GET_CURRENT_WORKSPACE_FAIL = 'GET_CURRENT_WORKSPACE_FAIL'
export const GET_CURRENT_WORKSPACE_RESET = 'GET_CURRENT_WORKSPACE_RESET'

export const CREATE_WORKSPACE_INITIAL_REQUEST = 'CREATE_WORKSPACE_INITIAL_REQUEST'
export const CREATE_WORKSPACE_INITIAL_SUCCESS = 'CREATE_WORKSPACE_INITIAL_SUCCESS'
export const CREATE_WORKSPACE_INITIAL_FAIL = 'CREATE_WORKSPACE_INITIAL_FAIL'
export const CREATE_WORKSPACE_INITIAL_RESET = 'CREATE_WORKSPACE_INITIAL_RESET'

export const CREATE_WORKSPACE_REQUEST = 'CREATE_WORKSPACE_REQUEST'
export const CREATE_WORKSPACE_SUCCESS = 'CREATE_WORKSPACE_SUCCESS'
export const CREATE_WORKSPACE_FAIL = 'CREATE_WORKSPACE_FAIL'
export const CREATE_WORKSPACE_RESET = 'CREATE_WORKSPACE_RESET'

export const EDIT_WORKSPACE_REQUEST = 'EDIT_WORKSPACE_REQUEST'
export const EDIT_WORKSPACE_SUCCESS = 'EDIT_WORKSPACE_SUCCESS'
export const EDIT_WORKSPACE_FAIL = 'EDIT_WORKSPACE_FAIL'
export const EDIT_WORKSPACE_RESET = 'EDIT_WORKSPACE_RESET'